import { ref } from 'vue';
import MetricaBillingAPI from 'dashboard/api/metrica/billing';

// Shared trial/subscription access state (Prime Insight — assinaturas). Fetched once
// per dashboard mount from the allowlisted /metrica/billing endpoint; drives the
// app-wide MetricaAccessWall when the free trial ended without a subscription.
const accessBlocked = ref(false);
const status = ref(null);
const loaded = ref(false);

export function useMetricaAccess() {
  const fetchAccess = async () => {
    try {
      const { data } = await MetricaBillingAPI.status();
      status.value = data;
      accessBlocked.value = Boolean(data.access_blocked);
    } catch {
      // Never block the app on a status-fetch failure.
      accessBlocked.value = false;
    } finally {
      loaded.value = true;
    }
  };

  return { accessBlocked, status, loaded, fetchAccess };
}
